import TeamStatsToDisplay from '~/constants/TeamStatsToDisplay';

const formatStatDisplay = teamSplit => stat => {
  const rank = teamSplit[`${stat.key}_rank`];
  const value = teamSplit[stat.key];
  return {
    name: stat.key,
    rank,
    value,
  };
};

const formatTeamSplitStats = teamSplit => {
  const pitchingStats = TeamStatsToDisplay.mlb_pitching.map(formatStatDisplay(teamSplit));
  const battingStats = TeamStatsToDisplay.mlb_batting.map(formatStatDisplay(teamSplit));
  const overviewStats = TeamStatsToDisplay.mlb_overview.map(formatStatDisplay(teamSplit));
  return pitchingStats.concat(battingStats).concat(overviewStats);
};

const normalizeBaseballScoringSummary = event => {
  const teamsByApiUri = {};
  teamsByApiUri[event.away_team.api_uri] = event.away_team;
  teamsByApiUri[event.home_team.api_uri] = event.home_team;
  const scoringPlays = event.box_score.scoring_plays.map(scoring => {
    const scoringPlay = scoring;
    scoringPlay.segment = scoringPlay.segment_number;
    if (scoringPlay.batter && scoringPlay.batter.full_name) {
      scoringPlay.player = scoringPlay.batter;
    } else if (scoringPlay.runner && scoringPlay.runner.full_name) {
      scoringPlay.player = scoringPlay.runner;
    } else {
      scoringPlay.player = { teams: [] };
    }
    scoringPlay.segment_string = `${scoringPlay.formatted_segment_number} inning`;
    scoringPlay.team = teamsByApiUri[scoringPlay.team];
    scoringPlay.player.teams[0] = scoringPlay.team;
    return scoringPlay;
  });
  return scoringPlays;
};

const normalizeBaseballEvent = event => {
  const newEvent = event;
  if (event.box_score && event.box_score.scoring_plays.length) {
    newEvent.scoring_plays = normalizeBaseballScoringSummary(event);
  }
  if (event.team_splits && event.team_splits.home && event.team_splits.away) {
    newEvent.home_stats_groups = [{ stats: formatTeamSplitStats(event.team_splits.home) }];
    newEvent.away_stats_groups = [{ stats: formatTeamSplitStats(event.team_splits.away) }];
  }
  return newEvent;
};

export default normalizeBaseballEvent;
